import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "./Home/assets/mslogo1.png";

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [touched, setTouched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValid(regex.test(value));
  };

  const handleSubmit = async () => {
    if (!isValid) return;
    setLoading(true);
    setSuccess(false);

    // Simulate API call
    setTimeout(() => {
      setLoading(false);
      setSuccess(true);
      setEmail("");
      setTouched(false);
      setTimeout(() => setSuccess(false), 3000); // hide success after 3s
    }, 1500);
  };

  return (
    <footer className="bg-gradient-to-b from-white to-gray-50 text-gray-800 py-10 border-t border-gray-200">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-[1fr_1fr_1fr_1fr_2fr] gap-6 items-start"
      >
        {/* Logo */}
        <motion.div variants={fadeInUp}>
          <img src={logo} alt="M.S. Education Logo" className="w-28 mb-4" />
        </motion.div>

        {/* Sitemap */}
        <motion.div variants={fadeInUp}>
          <h4 className="uppercase text-sm font-semibold mb-4 relative group">
            Sitemap
            <span className="absolute left-0 -bottom-1 w-0 h-0.5 bg-blue-500 transition-all group-hover:w-full"></span>
          </h4>
          <ul className="space-y-2 text-sm">
            {[
              { name: "Home", link: "/" },
              { name: "About Us", link: "/about" },
              { name: "Counselling", link: "/counselling" },
              { name: "Contact", link: "/contact" },
            ].map((item, i) => (
              <motion.li
                key={i}
                whileHover={{ x: 4, color: "#2563eb" }}
                transition={{ type: "spring", stiffness: 200 }}
              >
                <a href={item.link}>{item.name}</a>
              </motion.li>
            ))}
          </ul>
        </motion.div>

        {/* Countries */}
        <motion.div variants={fadeInUp}>
          <h4 className="uppercase text-sm font-semibold mb-4 relative group">
            Countries
            <span className="absolute left-0 -bottom-1 w-0 h-0.5 bg-blue-500 transition-all group-hover:w-full"></span>
          </h4>
          <ul className="space-y-2 text-sm">
            {[
              { name: "USA", link: "/country-overview/usa" },
              { name: "UK", link: "/country-overview/uk" },
              { name: "Canada", link: "/country-overview/canada" },
              { name: "Australia", link: "/country-overview/australia" },
              { name: "Europe", link: "/country-overview/europe" },
              // { name: "New Zealand", link: "/country-overview/new-zealand" },
            ].map((item, i) => (
              <motion.li
                key={i}
                whileHover={{ x: 4, color: "#2563eb" }}
                transition={{ type: "spring", stiffness: 200 }}
              >
                <a href={item.link}>{item.name}</a>
              </motion.li>
            ))}
          </ul>
        </motion.div>

        {/* Test Prep */}
        <motion.div variants={fadeInUp}>
          <h4 className="uppercase text-sm font-semibold mb-4 relative group">
            Test Prep
            <span className="absolute left-0 -bottom-1 w-0 h-0.5 bg-blue-500 transition-all group-hover:w-full"></span>
          </h4>
          <ul className="space-y-2 text-sm">
            {[
              { name: "IELTS", link: "/ielts" },
              // { name: "TOEFL", link: "/toefl" },
              // { name: "SAT", link: "/sat" },
              // { name: "PTE", link: "/pte" },
              // { name: "Duolingo", link: "/duolingo" },
            ].map((item, i) => (
              <motion.li
                key={i}
                whileHover={{ x: 4, color: "#2563eb" }}
                transition={{ type: "spring", stiffness: 200 }}
              >
                <a href={item.link}>{item.name}</a>
              </motion.li>
            ))}
          </ul>
        </motion.div>

        {/* Head Office + Newsletter */}
        <motion.div variants={fadeInUp}>
          <h4 className="uppercase text-sm font-semibold mb-4">Head Office</h4>
          <p className="text-sm mb-6">
            M.S House, Nr. Panchal Hall, A.V. Road, Anand, Gujarat, India.
          </p>
          <p className="text-sm mb-6">anand@mseconsultant.com</p>
          <p className="text-sm mb-6">+91 9510142218</p>
          {/* <h4 className="uppercase text-sm font-semibold mb-2">Newsletter</h4> */}
          {/* <div
            className={`flex items-center border-b pb-1 transition-colors ${
              touched && !isValid
                ? "border-red-500"
                : isValid
                ? "border-green-500"
                : "border-gray-400"
            }`}
          >
            <input
              type="email"
              placeholder="Enter your email address"
              className="bg-transparent outline-none text-sm flex-1 w-full"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                validateEmail(e.target.value);
              }}
              onBlur={() => setTouched(true)}
            />

            <button
              onClick={handleSubmit}
              disabled={!isValid || loading}
              className="ml-2 text-blue-500 hover:text-blue-600 disabled:text-gray-400"
            >
              <AnimatePresence>
                {loading ? (
                  <motion.div
                    className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                  ></motion.div>
                ) : (
                  <motion.svg
                    key="send-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    className="w-5 h-5"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 8l7.89 5.26c.42.28.96.28 1.38 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </motion.svg>
                )}
              </AnimatePresence>
            </button>
          </div> */}
          {/* {success && (
            <motion.p
              className="text-green-500 text-sm mt-2"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              ✅ Subscription successful!
            </motion.p>
          )} */}
        </motion.div>
      </motion.div>

      {/* Bottom Row */}
      <motion.div
        variants={fadeInUp}
        className="flex mx-auto px-6 mt-10 flex-col md:flex-row items-center justify-center text-sm text-gray-600"
      >
        <p>© 2020 M.S. Education All rights reserved.</p>
      </motion.div>
    </footer>
  );
};

export default Footer;
